import { Pipe, PipeTransform } from '@angular/core';
import { Invoice } from '../../../model/document.model';

@Pipe({
  standalone: true,
  name: 'jobReportInvoiceFilter',
  pure: true
})
export class JobReportInvoiceFilterPipe implements PipeTransform {
  transform(list: any[]) {
    if (!list?.length) {
      return [];
    }

    return list.filter(({ type }) => type === 'INVOICE').map((document) => document.document as Invoice);
  }
}
